'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Draws the detected boxes on top of an image
 */
var DetectionBox = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DetectionBox, _Component);

  function DetectionBox(props) {
    (0, _classCallCheck3.default)(this, DetectionBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DetectionBox.__proto__ || (0, _getPrototypeOf2.default)(DetectionBox)).call(this, props));

    _this.state = {
      onHover: false,
      // Disable playVideo eslint due to this issue https://github.com/yannickcr/eslint-plugin-react/issues/1697
      playVideo: false // eslint-disable-line
    };

    _this.onHoverEnter = _this.onHoverEnter.bind(_this);
    _this.onHoverExit = _this.onHoverExit.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DetectionBox, [{
    key: 'onHoverEnter',
    value: function onHoverEnter() {
      this.setState({ onHover: true });
    }
  }, {
    key: 'onHoverExit',
    value: function onHoverExit() {
      this.setState({ onHover: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          detectionObj = _props.detectionObj,
          imageHeight = _props.imageHeight,
          imageWidth = _props.imageWidth,
          recordingReason = _props.recordingReason;


      var width = detectionObj.width * imageWidth;
      var height = detectionObj.height * imageHeight;

      var left = detectionObj.x * imageWidth - width / 2;
      var top = detectionObj.y * imageHeight - height / 2;

      var color = '3px solid rgba(115, 173, 33, 0.8)';

      if (detectionObj.caused_recording) {
        color = '3px solid red';
      }

      var style = {
        border: color,
        position: 'absolute',
        left: left,
        top: top,
        width: width,
        height: height
      };

      // const hoverStyle = {};

      var detectionString = function detectionString() {
        var outputString = detectionObj.confidence + '% ' + detectionObj.type;

        if ('intersection_of_union' in detectionObj) {
          var iou = detectionObj.intersection_of_union.toFixed(2);
          outputString = outputString + ' IOU: ' + iou;
        }

        if ('mse_overlap' in detectionObj) {
          var mse = detectionObj.mse_overlap.toFixed(2);
          outputString = outputString + ' MSE: ' + mse;
        }

        return outputString;
      };

      var notRecordedReason = function notRecordedReason() {
        var outputArray = [];

        if (!('is_confident' in detectionObj) && 'sight_confidence' in recordingReason) {
          detectionObj.is_confident = detectionObj.confidence > recordingReason.sight_confidence;
        }

        if (detectionObj.is_in_aoi === false) {
          outputArray.push('in aoi');
        }
        if (detectionObj.is_moving === false) {
          outputArray.push('moving');
        }
        if (detectionObj.is_confident === false) {
          outputArray.push('confident');
        }

        if (outputArray.length > 0) {
          return ' NOT ' + outputArray.join('/');
        }
        return null;
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', {
          style: style,
          title: (0, _stringify2.default)(detectionObj, null, 2),
          onMouseEnter: this.onHoverEnter,
          onMouseLeave: this.onHoverExit
        }),
        this.state.onHover && _react2.default.createElement(
          'div',
          null,
          detectionString(),
          _react2.default.createElement(
            'b',
            null,
            notRecordedReason()
          )
        )
      );
    }
  }]);
  return DetectionBox;
}(_react.Component), _class.propTypes = {
  detectionObj: _react.PropTypes.object,
  recordingReason: _react.PropTypes.object,
  imageHeight: _react.PropTypes.number,
  imageWidth: _react.PropTypes.number
}, _temp);
exports.default = DetectionBox;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DetectionBox/DetectionBox.js
 ** module id = 1383
 ** module chunks = 0
 **/